import React from "react";
import paymentStatusEnum from "../../data/paymentStatusEnum";
import useFunction from "../../hooks/useFunction";
import usePrice from "../../hooks/usePrice";
import Button from "../Button/Button";
import PropTypes from "prop-types";
import useInvoiceService from "../../api/services/useInvoiceService";

const OutgoingPaymentRow = ({outgoingPayment, showLinksToBooking = false}) => {
  const {formatPrice} = usePrice()
  const {dateTime} = useFunction()
  const {handleStreamReceiptPdf} = useInvoiceService()

  const getPaymentStatusLabel = (value) => {
    return paymentStatusEnum.find(status => status.value === value).labelOutgoing
  }

  console.log('outgoingPayment',outgoingPayment)

  return (
    <div className="component-outgoing-payment-row">
      <div className="fields">

        <div className="field status">
          <p className={"label"}>Status:</p>
          {getPaymentStatusLabel(outgoingPayment.status)}
          {outgoingPayment.booking &&
            <>
              {showLinksToBooking
                ? <p><Button size="xs" color="grey-ghost" link={"/user/boeking/" + outgoingPayment.booking.id} label="Boeking"/>
                </p>
                : <>
                  <p className={"label"}>Boeking ID:</p>
                  <p>{outgoingPayment.booking.booking_number}</p>
                </>
              }
            </>
          }
        </div>

        {outgoingPayment.amount &&
          <div className="field amount">
            <p className={"label"}>Bedrag (incl. btw):</p>
            <p>{formatPrice(outgoingPayment.amount)}</p>
          </div>
        }

        <div className="field pay">
          <Button
            label="Download bon"
            onClick={() => handleStreamReceiptPdf(outgoingPayment.receipt_id)}
            debounce={3000}
            target="_blank"
          />
        </div>

        <div className="field meta">
          <p className={"label"}>Aangemaakt:</p>
          <p>{dateTime(outgoingPayment.created_at)}</p>

          {outgoingPayment.updated_at !== null && outgoingPayment.updated_at !== outgoingPayment.created_at &&
            <>
              <p className={"label"}>Geupdate:</p>
              <p>{dateTime(outgoingPayment.updated_at)}</p>
            </>
          }
        </div>

      </div>
    </div>
  )
}

OutgoingPaymentRow.prototype = {
  outgoingPayment: PropTypes.object.isRequired,
  showLinksToBooking: PropTypes.bool,
}

export default OutgoingPaymentRow;